<template>
  <div class="page-404">
    <div class="page-404__eyecatch" :class="{'is-loaded': bgLoad}">
      <transition>
        <img v-show="bgLoad" class="page-404__img--1"
             :src="[$route.path.match(/gogatsu/) ? '/choice/img/404/img-1-gogatsu.jpg' : '/choice/img/404/img-1.jpg']"
             @load="bgLoad = true" alt="">
      </transition>
      <transition>
        <img v-show="bgLoad" class="page-404__img--2" src="/choice/img/404/img-2.png" alt="">
      </transition>
      <transition>
        <img v-show="bgLoad" class="page-404__img--3" src="/choice/img/404/img-3.png" alt="">
      </transition>
      <transition>
        <img v-show="bgLoad" class="page-404__img--4" src="/choice/img/404/img-4.png" alt="">
      </transition>
      <transition>
        <router-link v-show="bgLoad" class="page-404__link" :to="$route.path.match(/gogatsu/) ?  config.path.root_gogatsu : config.path.root">
          <img src="/choice/img/404/img-5.png" alt="">
          <img class="page-404__link-hover-img"
               :src="[$route.path.match(/gogatsu/) ? '/choice/img/404/img-5-hover_gogatsu.png' : '/choice/img/404/img-5-hover.png']"
               alt="">
        </router-link>
      </transition>
    </div>

    <v-footer/>
  </div>
</template>



<script>
export default {
  components: {
    'v-footer': require('@/components/footer.vue').default,
  },
  data() {
    return {
      bgLoad: false,
    }
  },
  methods: {
    imgLoad() {
    },
  }
}
</script>



<style lang="scss">
.page-404 {
  $e: &;
  background-color: #f8f6f5;
  width: 100%;
  height: 100%;
  padding-top: 392px;
  @include breakpoints-min(sm) {
    padding-top: 482px;
  }
  @include breakpoints-min(md) {
    padding-top: 632px;
  }

  &__eyecatch {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 32px;
    width: 720px;
    height: 360px;
    @include breakpoints-min(sm) {
      width: 900px;
      height: 450px;
    }
    @include breakpoints-min(md) {
      top: 32px;
      width: 1200px;
      height: 600px;
    }
  }
  &__img {
    position: absolute;
    &--1 {
      @extend #{$e}__img;
      top: 0;
      left: 0;
      z-index: 1;
      width: 720px;
      height: 360px;
      @include breakpoints-min(sm) {
        width: 900px;
        height: 450px;
      }
      @include breakpoints-min(md) {
        width: 1200px;
        height: 600px;
      }
    }
    &--2 {
      @extend #{$e}__img;
      top: 188px;
      left: 404px;
      z-index: 2;
      width: 11px;
      height: 7px;
      @include breakpoints-min(sm) {
        top: 230px;
        left: 487px;
        width: 14px;
        height: 8px;
      }
      @include breakpoints-min(md) {
        top: 314px;
        left: 674px;
        width: 19px;
        height: 11px;
      }
    }
    &--3 {
      @extend #{$e}__img;
      top: 171px;
      left: 416px;
      z-index: 3;
      width: 28px;
      height: 17px;
      @include breakpoints-min(sm) {
        top: 214px;
        left: 521px;
        width: 35px;
        height: 22px;
      }
      @include breakpoints-min(md) {
        top: 285px;
        left: 694px;
        width: 46px;
        height: 29px;
      }
    }
    &--4 {
      @extend #{$e}__img;
      top: 37px;
      left: 380px;
      z-index: 4;
      width: 168px;
      height: 159px;
      @include breakpoints-min(sm) {
        top: 46px;
        left: 476px;
        width: 210px;
        height: 199px;
      }
      @include breakpoints-min(md) {
        top: 51px;
        left: 634px;
        width: 280px;
        height: 265px;
      }
    }
  }
  &__link {
    display: block;
    position: absolute;
    top: 38px;
    left: 313px;
    z-index: 5;
    img {
      width: 97px;
      height: 109px;
    }
    #{$e}__link-hover-img {
      width: 94px;
      height: auto;
    }
    @include breakpoints-min(sm) {
      top: 48px;
      left: 391px;
      img {
        width: 122px;
        height: 139px;
      }
      #{$e}__link-hover-img {
        width: 118px;
      }
    }
    @include breakpoints-min(md) {
      top: 64px;
      left: 521px;
      img {
        width: 162px;
        height: 181px;
      }
      #{$e}__link-hover-img {
        width: 155px;
      }
    }
  }
  &__link-hover-img {
    transition: $transition;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    &:hover {
      opacity: 1;
    }
  }

  .v {
    &-enter,
    &-leave-to {
      opacity: 0;
    }
    &-enter-to,
    &-leave {
      opacity: 1;
    }
    &-enter-active,
    &-leave-active {
      &.page-404__img--1 {
        transition: 1s ease-out;
      }
      &.page-404__img--2 {
        transition: 0.5s 0.5s ease-out;
      }
      &.page-404__img--3 {
        transition: 0.5s 1s ease-out;
      }
      &.page-404__img--4 {
        transition: 0.5s 1.5s ease-out;
      }
      &.page-404__link {
        transition: 0.5s 2.5s ease-out;
      }
    }
  }
}

.app-gogatsu .page-404 {

}
</style>
